import { useContext } from "react";
import {
  ControlPresentationContext,
  type ControlPresentation,
} from "./ControlPresentationContext";

/**
 * The active control presentation, defaulting to `boxed` (the dense look) when
 * no `ControlPresentationProvider` is present — so screens are dense by
 * default and only the spacious flows opt into `underlined`. Only meaningful in
 *
 */
export function useControlPresentation(): ControlPresentation {
  return useContext(ControlPresentationContext) ?? "boxed";
}
